import React from "react";
import styled, { css, keyframes } from "styled-components";

import { ScalingContainer } from "../../../AppStyled";

import { ReactComponent as BackSvg } from "../../../assets/back.svg";

import { ReactComponent as MenuSVG } from "../../../assets/menu.svg";
import { ReactComponent as PlusSVG } from "../../../assets/plus.svg";
import { ReactComponent as MinusSVG } from "../../../assets/minus.svg";
import { ReactComponent as AutoSVG } from "../../../assets/auto.svg";
import { ReactComponent as FastSVG } from "../../../assets/fast.svg";

import { HistoryContainer } from "../history/HistoryStyled";
import WinningStreak from "./GameRulesStyled";
import useSound from "use-sound";
import goBack from "../../../audio/goBack.mp3";

const btnRotate = keyframes`
  0% {
    transform: rotate(-45deg);
    animation-timing-function: cubic-bezier(0.23, 0.07, 0.08, 0.91);
  }
  33% {
    transform: rotate(13.34deg);
    animation-timing-function: cubic-bezier(0.28, -0.06, 0.61, 0.89);
  }
  66% {
    transform: rotate(-10.65deg);
    animation-timing-function: cubic-bezier(0.32, -0.18, 0.66, 1);
  }
  100% {
    transform: rotate(0deg);
  }
`;
const btnRotateAnim = css`
  ${btnRotate} 500ms forwards
`;
const Back = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 36px;
  height: 36px;
  border-radius: 18px;
  background-color: #6b66c7;
  cursor: pointer;
  svg {
    animation: ${btnRotateAnim};

    /* background: #ffb000; */
    /* padding: 10px;
    border-radius: 50%; */
  }
`;
const HeaderD = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
  margin-bottom: 40px;
  height: 40px;

  p {
    font-size: 26px;
  }
  svg {
    g {
      stroke: #32075b;
    }
  }
`;
const Header = ({ name, handleAbove, userSettings: { sound, volume } }) => {
  const [goBackSfx] = useSound(goBack, { volume });

  return (
    <HeaderD>
      <p>{name}</p>
      <Back
        onClick={() => {
          if (sound) goBackSfx();
          handleAbove(false);
        }}
      >
        <BackSvg />
      </Back>
    </HeaderD>
  );
};

export const OPDescriptionContainer = styled.div`
  display: flex;
  align-items: flex-start;
  margin-bottom: 20px;
`;

export const OPDescriptionBox = styled.div`
  p:first-child {
    font-family: "GT America, boldN";
    margin-bottom: 10px;
  }
`;

export const MenuBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  border-radius: 38px;
  margin-right: 10px;
  color: #ff3920;
  font-size: 14px;
  height: 42px;
  width: 42px;
  svg {
    width: 26px;
    height: 26px;
    g {
      stroke: #6b66c7;
    }
  }
`;
export const OPDescriptionIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  border-radius: 38px;
  background: #ffb000;
  margin-right: 10px;
  color: #ff3920;
  font-size: 14px;
  height: 42px;
  width: 42px;
  svg {
    width: 20px;
    height: 20px;
    g {
      stroke: #ff3920;
    }
  }
`;

export const OPDescription = styled.div`
  margin-bottom: 30px;
  line-height: 1;
  h3 {
    font-size: 15px;
    margin-bottom: 8px;
  }
  p {
    font-size: 11px;
    font-family: "GT America, regular";
  }
  @media only screen and (min-width: 375px) {
    h3 {
      font-size: 20px;
    }
    p {
      font-size: 12px;
    }
  }
`;

export default function GameRules({ handleAbove, unBlur, h, userSettings }) {
  return (
    <HistoryContainer className="HistoryContainer" unBlur={unBlur}>
      <ScalingContainer className="ScalingContainer" h={h}>
        <div
          style={{
            maxHeight: "607px",
            maxWidth: "315px",
            overflowY: "scroll",
            overflowX: "hidden",
            margin: "auto",
          }}
        >
          <Header
            name={"GAME RULES"}
            handleAbove={handleAbove}
            userSettings={userSettings}
          />
          <OPDescription>
            <h3>Spheres</h3>
            <br />
            <p>1) Beat the dealer’s combination to Win the game</p>
            <br />
            <p>2) 5 of a kind is the best possible combo</p>
            <br />
            <p>3) If you score a Full House,  the profit is 0.75 to 1 </p>
            <br />
            <p>4) Traditional poker rankings apply</p>
            <br />
            <p>5) Coefficient of a Win is 2x, draw – 1x and loss - 0</p>
            <br />
          </OPDescription>
          <OPDescription>
            <h4>
              Game has 7 different colored balls and 6 combinations to win:
            </h4>
            <WinningStreak
              headline="Pair"
              description="doubles the bet"
              backgrounds={[5, 5, 2, 1, 4]}
            />
            <WinningStreak
              headline="TWO PAIR "
              description="doubles the bet"
              backgrounds={[5, 5, 1, 1, 3]}
            />
            <WinningStreak
              headline="3 OF A KIND "
              description="doubles the bet"
              backgrounds={[5, 2, 1, 1, 1]}
            />
            <WinningStreak
              headline="4 OF A KIND"
              description="doubles the bet"
              backgrounds={[5, 5, 5, 5, 1]}
            />
            <WinningStreak
              headline="FULL HOUSE"
              description="bet multiplies by 0.75X"
              backgrounds={[5, 5, 1, 1, 1]}
            />
            <WinningStreak
              headline="5 OF A KIND"
              description="doubles the bet"
              backgrounds={[5, 5, 5, 5, 5]}
            />
          </OPDescription>
          <OPDescription>
            <h3>Settings</h3>
            <OPDescriptionContainer>
              <MenuBox width="42px" height="42px">
                <MenuSVG />
              </MenuBox>
              <OPDescriptionBox>
                <p>Settings button</p>
                <p>Press the button to access Settings.</p>
              </OPDescriptionBox>
            </OPDescriptionContainer>
            <p>
              <b> Provably Fair</b> – This section grants you the possibility of
              checking the fairness of the game for yourself. <br />
              <br />
              <b> Game Rules</b> – Short Description of the Game. <br />
              <br />
              <b> History </b>– Shows your previous plays and allows you to
              devise new tactics for your next shuffle. <br />
              <br />
              <b> Music</b> - Turn on the unique audio overlay of the game.{" "}
              <br />
              <br />
              <b> Sound </b> – Enable unique sounds of the game. <br />
              <br />
              <b> Volume Bar </b>– Set the volume.
            </p>
          </OPDescription>

          <OPDescription>
            <h3>Gameplay Customization </h3>
            <p>
              <b>Play Button</b> – Start the Game. <br />
              <br />
            </p>
            <OPDescriptionContainer>
              <OPDescriptionIcon>2X</OPDescriptionIcon>
              <OPDescriptionBox>
                <p>2x Button</p>
                <p>Doubles your bet instantly.</p>
              </OPDescriptionBox>
            </OPDescriptionContainer>
            <OPDescriptionContainer>
              <OPDescriptionIcon>1/2</OPDescriptionIcon>
              <OPDescriptionBox>
                <p>1/2 Button</p>
                <p>Divides your bet by half.</p>
              </OPDescriptionBox>
            </OPDescriptionContainer>
            <p>
              Options: <br /> <br />
            </p>
            <OPDescriptionContainer>
              <OPDescriptionIcon>5X</OPDescriptionIcon>
              <OPDescriptionBox>
                <p>5x Button</p>
                <p>Multiply your bet by 5.</p>
              </OPDescriptionBox>
            </OPDescriptionContainer>
            <OPDescriptionContainer>
              <OPDescriptionIcon>
                <PlusSVG />
              </OPDescriptionIcon>
              <OPDescriptionBox>
                <p>+ button</p>
                <p>Increase amount by a single unit.</p>
              </OPDescriptionBox>
            </OPDescriptionContainer>
            <OPDescriptionContainer>
              <OPDescriptionIcon>
                <MinusSVG />
              </OPDescriptionIcon>
              <OPDescriptionBox>
                <p>- button</p>
                <p>Decrease amount by a single unit.</p>
              </OPDescriptionBox>
            </OPDescriptionContainer>
            <OPDescriptionContainer>
              <OPDescriptionIcon>
                <FastSVG />
              </OPDescriptionIcon>
              <OPDescriptionBox>
                <p>quickplay button</p>
                <p>Turn on the Quickplay</p>
              </OPDescriptionBox>
            </OPDescriptionContainer>
            <OPDescriptionContainer>
              <OPDescriptionIcon>
                <AutoSVG />
              </OPDescriptionIcon>
              <OPDescriptionBox>
                <p>auto button</p>
                <p>switch to auto interface.</p>
              </OPDescriptionBox>
            </OPDescriptionContainer>
            Auto play Options: <br />
            <p>
              <br />
              <b> Number of Bets</b> – Set the Number of Your Bets. <br />
              <br />
              <b> On Win </b>- In this field you can input an option to increase
              or decrease the bet percentage after the winning hand.
              <br />
              <br /> <b>On Loss </b>– In this field you can input an option to
              increase or decrease the bet percentage after the losing hand.
              <br />
              <br />
              <b> Stop on Profit </b>– Enables you to stop autoplay when a
              certain profit number is reached. <br />
              <br /> <b>Stop on Loss</b> - Enables you to stop autoplay when a
              certain amount is lost. <br />
            </p>
            <br />
            <OPDescriptionContainer>
              <OPDescriptionIcon>
                <PlusSVG />
              </OPDescriptionIcon>
              <OPDescriptionBox>
                <p>+ button</p>
                <p>Increase amount by a single unit.</p>
              </OPDescriptionBox>
            </OPDescriptionContainer>
            <OPDescriptionContainer>
              <OPDescriptionIcon>
                <MinusSVG />
              </OPDescriptionIcon>
              <OPDescriptionBox>
                <p>- button</p>
                <p>Decrease amount by a single unit.</p>
              </OPDescriptionBox>
            </OPDescriptionContainer>
          </OPDescription>
        </div>
      </ScalingContainer>
    </HistoryContainer>
  );
}
